import { PublicClientApplication } from "@azure/msal-browser";

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID!,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin + "/.auth/login/aad/callback",
  },
});